import styled from "styled-components";

import { HEXtoRGBA } from "@/styles/helper";
import { fadeIn, zoomOut } from "@/styles/Mixins";

export const Text = styled.div`
  font-size: ${(props: any) => props.theme.typography.h500};
  font-weight: 300;
  color: ${(props: any) => props.theme.colors.resultGlassText};
  span {
    font-weight: 600;
  }
`;

export const Water = styled.div<any>`
  width: 100%;
  height: ${(props: any) => props.percent}%;
  background-color: ${(props: any) => props.theme.colors.resultGlass};
  position: absolute;
  bottom: 0;
  transition: height 1.5s linear;
  mask-image: radial-gradient(white, black);
`;

export const Share = styled.div`
  flex: none;
  position: relative;
  flex-direction: row;
  height: 24px;
  line-height: 24px;
`;

export const MoreInfo = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 100%;
  left: 0;
  width: 100%;
  text-align: center;
`;

export const Circle = styled.div`
  border-radius: 50%;
  width: 260px;
  height: 260px;
  background-clip: padding-box;
  ${(props: any) => {
    return `border: 11px solid ${props.theme.colors.resultGlassBorder ||
      HEXtoRGBA(props.theme.colors.resultGlassBackground, 0.5)};
        background-color: ${HEXtoRGBA(
          props.theme.colors.resultGlassBackground,
          0.5
        )};`;
  }}
  overflow: hidden;
  mask-image: radial-gradient(white, black);
  animation: ${zoomOut} 750ms linear;
`;

export const InnerCircle = styled.div`
  border-radius: 50%;
  width: 100%;
  height: 100%;
  border: ${(props: any) =>
    `${props.theme.borders.resultGlass} solid ${props.theme.colors
      .resultGlassBorder || props.theme.colors.white}`};
  text-align: center;
  overflow: hidden;
  position: relative;
`;

export const ResultCircle = styled.div`
  position: relative;
  width: 100%;
  font-size: ${(props: any) => props.theme.typography.h900};
  font-weight: bold;
  color: ${(props: any) => props.theme.colors.resultGlassText};
  animation: ${fadeIn} 0.15s ease-in;
`;

export const ResultWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  margin-top: -${(props: any) => props.theme.spacing.desktop.s200}px;
`;

export const CounterWrapper = styled.div`
  margin-bottom: 0;
`;

export const IconWrapper = styled.fieldset<any>`
  display: inline-flex;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  margin-left: ${(props: any) => props.theme.spacing.desktop.s100}px;
  margin-right: ${(props: any) => props.theme.spacing.desktop.s100}px;
`;
